import { useState } from 'react';
import PropTypes from 'prop-types';
import { useErrors } from 'Components/Organisms/ErrorsProvider';
import InputFileCSV from 'Components/Molecules/InputFileCSV/InputFileCSV';
import Button from 'Components/Atoms/Button/Button';
import { useTranslation } from 'react-i18next';

export default function ImportFileUpload(props) {
    const {
        onClose,
        onSubmit,
        onChangeProcessing,
        processing,
        title,
        description,
        buttonText,
        importService,
        children,
        disabled,
        extraFileExtensions,
        dropText,
    } = props;
    const [file, setFile] = useState(null);

    const { showUnknownError } = useErrors();
    const { t } = useTranslation('common');
    const handleSubmit = async () => {
        onChangeProcessing(true);
        try {
            const response = await importService(file);
            onSubmit(response);
        } catch (error) {
            showUnknownError(error);
            onClose();
        } finally {
            onChangeProcessing(false);
        }
    };

    return (
        <div className="flex flex-col h-full">
            <div className="mb-12">
                {title && <h4>{title}</h4>}
                <div className="text-gray-500">{description}</div>
            </div>

            <div className="grow">
                {children}
                <InputFileCSV
                    file={file}
                    onChange={setFile}
                    extraFileExtensions={extraFileExtensions}
                    dropText={dropText}
                />
            </div>

            <div className="sticky bottom-0 bg-white pt-2 pb-4 z-10">
                <div className="flex gap-2">
                    <Button
                        isBusy={processing}
                        className="grow"
                        disabled={!file || disabled}
                        onClick={handleSubmit}
                        variant="primary"
                    >
                        {buttonText}
                    </Button>
                    <Button className="grow" onClick={onClose}>
                        {t('cancel')}
                    </Button>
                </div>
            </div>
        </div>
    );
}

ImportFileUpload.propTypes = {
    onClose: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onChangeProcessing: PropTypes.func.isRequired,
    processing: PropTypes.bool.isRequired,
    title: PropTypes.node,
    description: PropTypes.node.isRequired,
    buttonText: PropTypes.string.isRequired,
    importService: PropTypes.func.isRequired,
    children: PropTypes.node,
    disabled: PropTypes.bool,
    extraFileExtensions: PropTypes.arrayOf(PropTypes.string),
    dropText: PropTypes.string,
};
